import WFS from 'ol/format/WFS';
import axios from 'axios';

const WFSRequest = {

  /**
   * Sends a WFS request.
   * This supports formatting of Geoserver custom parameter 'viewParams'.
   * @param {String} url URL
   * @param {Object} options Options for the WFS request.
   * @returns {AxiosPromise} The promise returned by axios.
   */
  send (url, options, wfsVersion) {
    const wfs = new WFS(
      { version: wfsVersion || '1.1.0' }
    );

    const getFeatureOptions = {
      ...options,
      viewParams: this.serializeViewParams(options.viewParams)
    };
    const xmlNode = wfs.writeGetFeature(getFeatureOptions);
    const postData = new XMLSerializer().serializeToString(xmlNode);

    const request = {
      method: 'POST',
      url,
      headers: { 'Content-Type': 'text/xml' },
      data: postData
    };

    return axios(request);
  },

  /**
   * Serialize Geoserver WFS vendor parameter 'viewParams' with respect to escaping.
   * @param {Object} viewParams View params as a set of key value pairs.
   * @returns A string containing the formatting view params.
   */
  serializeViewParams (viewParams) {
    if (!viewParams) {
      return undefined;
    }

    return Object.entries(viewParams)
      .map(([key, value]) => {
        const escapedValue = value
          .replace(/,/g, '\\,')
          .replace(/;/g, '\\;')
        return `${key}:${escapedValue}`;
      })
      .join(';')
  }
}

export default WFSRequest;
